import React, { Component } from 'react';
import { connectStateResults } from 'react-instantsearch-dom';
import EventCalendarListing from '../components/EventCalendarListing';
import moment from '../utils/momentTimeZone'
import LoadMoreNextWeek from './LoadMoreNextWeek';


class ByDayHits extends Component {

    render() {
        const {hits, dateRange} = this.props
        return (
            <div>
                {hits.length === 0 && dateRange && dateRange.range && dateRange.range.unixDay &&
                <div className="o-layout o-layout--center">
                    <div className="o-layout__item u-1/1@desktop">
                        <div className="fadeIn c-no-events-label">
                            <p>
                                <strong>
                                    There are no events currently scheduled<br/>
                                    between {moment.unix(dateRange.range.unixDay.min).format('D MMMM')} and {moment.unix(dateRange.range.unixDay.max).format('D MMMM')}
                                </strong>
                            </p>
                            <button type="button" class="c-btn c-btn--red" onClick={this.onViewTodayClick}>View today's events</button>
                        </div>
                    </div>
                </div>
                }
                {hits.map(hit =>
                    <EventCalendarListing key={hit.objectID} hit={hit} />
                )}
                {hits.length > 0 &&
                <div className="c-whats-on-LoadMore">
                    <LoadMoreNextWeek attribute="unixDay" />
                </div>}
            </div>
        )
    }

    onViewTodayClick() {
        window.dispatchEvent(new CustomEvent("whatson:view-today"));
    }
}



export default connectStateResults(({dateRange, searchResults }) => {
    return (searchResults && <ByDayHits hits={searchResults.hits} dateRange={dateRange} />)
})



// WEBPACK FOOTER //
// ./src/whatson/components/ByDayHits.js